import React, { useState, useEffect } from "react";
import Button from "../../Button";
import apiInstance from "../../apiInstance";

const EditSubscriptionPopup = ({
    data,
    type = "add",
    updateSubscription,
    addSubscription,
    updateError,
    closePopup,
}) => {
    const [subscription, setSubscription] = useState({
        id: data?.subscription?._id || "",
        name: data?.subscription?.name || "",
        user: data?.subscription?.user || '',
        site: data?.subscription?.site || '',
        status: data?.subscription?.status || '',
        amount: data?.subscription?.amount || process.env.REACT_APP_STRIPE_MONTHLY_PRICING,
        currentPeriodEnd: data?.subscription?.currentPeriodEnd || '',
    });

    const [users, setUsers] = useState([]); 
    const [websites, setWebsites] = useState([]); 
    const [fieldErrors, setFieldErrors] = useState({}); 

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSubscription((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = () => {
        const apiCall =
            type === "update"
                ? apiInstance.put(`/devadmin/subscription/${subscription.id}`, subscription)
                : apiInstance.post(`/devadmin/subscription`, subscription);

        apiCall
            .then((response) => {
                const returnedSub = response.data.subscription;
                if (type === "update") {
                    updateSubscription(returnedSub);
                } else {
                    addSubscription(returnedSub);
                }
                closePopup();
            })
            .catch((error) => {
                console.log(error)
                if (error.response) {
                    if (
                        error.response.status === 400 &&
                        error.response.data.fieldErrors
                    ) {
                        setFieldErrors(error.response.data.fieldErrors);
                    } else {
                        updateError(error.response.data.message || 'Something went wrong, please try again later.');
                    }
                } 
            });
    };

    useEffect(() => {
        apiInstance
            .get("/devadmin/user")
            .then((res) => {
                setUsers(res.data.users || []);
            })
            .catch((err) => {
                console.error("Error fetching users:", err);
                updateError("Failed to load users.");
            });
    }, []);

    useEffect(() => {
        apiInstance
            .get("/devadmin/website")
            .then((res) => {
                setWebsites(res.data.websites || []);
            })
            .catch((err) => {
                console.error("Error fetching websites:", err);
                updateError("Failed to load websites.");
            });
    }, []);

    return (
        <div className="mjsdev-pp">
            <h2>{type === "add" ? "ADD SUBSCRIPTION" : "EDIT SUBSCRIPTION"}</h2>

            <form>
                <div className="mjsdev-input-field">
                    <label htmlFor="user">Customer</label>
                    <select
                        name="user"
                        value={subscription.user}
                        onChange={handleInputChange}
                    >
                        <option value="">Select Customer</option>
                        {users.map((user) => (
                            <option key={user._id} value={user._id}>
                                {user.name} [{user.email}]
                            </option>
                        ))}
                        
                    </select>
                    {fieldErrors.user && (
                        <span className="mjsdev-error">
                            {fieldErrors.user}
                        </span>
                    )}
                </div>

                <div className="mjsdev-input-field">
                    <label htmlFor="site">Site</label>
                    <select
                        name="site"
                        value={subscription.site}
                        onChange={handleInputChange}
                    >
                        <option value="">Select Site</option>
                        {websites.map((site) => (
                            <option key={site._id} value={site._id}>
                                {site.name}
                            </option>
                        ))}
                        
                    </select>
                    {fieldErrors.site && (
                        <span className="mjsdev-error">
                            {fieldErrors.site}
                        </span>
                    )}
                </div>

                <div className="mjsdev-input-field">
                    <label htmlFor="status">Status</label>
                    <select
                        name="status"
                        value={subscription.status}
                        onChange={handleInputChange}
                    >
                        <option value="">Select Status</option>
                        <option value="active">Active</option>
                        <option value="canceled">Canceled</option>
                        <option value="incomplete">Incomplete</option>
                        <option value="past_due">Past Due</option>
                        <option value="expired">Expired</option>
                        
                    </select>
                    {fieldErrors.status && (
                        <span className="mjsdev-error">
                            {fieldErrors.status}
                        </span>
                    )}
                </div>

                <div className="mjsdev-input-field">
                    <label htmlFor="amount">Amount($)</label>
                    <input
                        type="number"
                        placeholder="Amount($)"
                        name="amount"
                        value={subscription.amount}
                        onChange={handleInputChange}
                    />
                    {fieldErrors.amount && (
                        <span className="mjsdev-error">
                            {fieldErrors.amount}
                        </span>
                    )}
                </div>

                <div className="mjsdev-input-field">
                    <label htmlFor="currentPeriodEnd">Renewal Date</label>
                    <input
                        type="date"
                        placeholder="Renewal Date"
                        name="currentPeriodEnd"
                        value={subscription.currentPeriodEnd
                            ? new Date(subscription.currentPeriodEnd).toISOString().split("T")[0]
                            : ""}
                        onChange={handleInputChange}
                    />
                    {fieldErrors.currentPeriodEnd && (
                        <span className="mjsdev-error">
                            {fieldErrors.currentPeriodEnd}
                        </span>
                    )}
                </div>

            </form>

            <div className="mjsdev-pp-actions">
                <Button
                    name={type === "add" ? "Add" : "Update"}
                    eventHandler={handleSubmit}
                />
                <Button name="Cancel" eventHandler={closePopup} />
            </div>
        </div>
    );
};

export default EditSubscriptionPopup;
